<template>
  <transition name="confirm-fade">
    <div v-if="modelValue" class="confirm-overlay" @click.self="cancel">
      <div class="confirm-dialog" role="dialog" aria-modal="true" :aria-label="title || 'Confirmation'">
        <h3 class="confirm-title">{{ title }}</h3>
        <p class="confirm-message">{{ message }}</p>

        <div class="confirm-actions">
          <button type="button" class="confirm-btn confirm-btn--ghost" @click="cancel">
            {{ cancelLabel }}
          </button>
          <button
              type="button"
              class="confirm-btn"
              :class="{ 'confirm-btn--danger': danger }"
              @click="confirm"
          >
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmDialog',

  props: {
    cancelLabel: {
      type: String,
      default: 'Annuler'
    },
    confirmLabel: {
      type: String,
      default: 'Confirmer'
    },
    danger: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirmation'
    }
  },

  emits: ['cancel', 'confirm', 'update:modelValue'],

  methods: {
    cancel() {
      this.$emit('cancel');
      this.$emit('update:modelValue', false);
    },

    confirm() {
      this.$emit('confirm');
      this.$emit('update:modelValue', false);
    }
  }
}
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.46);
  padding: 28px 16px;
  box-sizing: border-box;
}

.confirm-dialog {
  width: min(440px, 100%);
  max-height: calc(100dvh - 56px);
  border-radius: 20px;
  background: #2b2c2f;
  border: 1px solid #4c515a;
  box-shadow: 0 0 22px rgba(0, 240, 255, 0.18);
  padding: 1.15rem;
  color: #f3f7ff;
  overflow: auto;
}

.confirm-title {
  margin: 0 0 0.65rem;
  color: #00f0ff;
  font-size: 1.15rem;
}

.confirm-message {
  margin: 0;
  color: #d8deeb;
  line-height: 1.5;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.confirm-btn {
  border: 1px solid #00f0ff;
  border-radius: 999px;
  background: rgba(0, 240, 255, 0.12);
  color: #00f0ff;
  padding: 0.65rem 1rem;
  cursor: pointer;
}

.confirm-btn--ghost {
  border-color: #50545d;
  background: #252629;
  color: #fff;
}

.confirm-btn--danger {
  border-color: #ff4d4d;
  background: rgba(255, 0, 0, 0.12);
  color: #ff8080;
}

.confirm-fade-enter-active,
.confirm-fade-leave-active {
  transition: opacity 0.18s ease;
}

.confirm-fade-enter-from,
.confirm-fade-leave-to {
  opacity: 0;
}
</style>
